/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injector } from '@rxdi/core';
import {
  ApolloClient,
  DataProxy,
  importQuery,
  MutationOptions,
  QueryOptions,
  SubscriptionOptions,
} from '@rxdi/graphql-client';
import { LitElement } from '@rxdi/lit-html';
import { from, Observable } from 'rxjs';

import { IMutation, IQuery, ISubscription } from '../@introspection';
import { DocumentTypes } from '../@introspection/documentTypes';

export class BaseComponent extends LitElement {
  @Injector(ApolloClient) public graphql: ApolloClient;
  // createRenderRoot() {
  //   return this;
  // }
  query<T = IQuery>(options: ImportQueryMixin, raw?: boolean) {
    if (!raw) {
      options.query = importQuery(options.query);
    }
    return from(this.graphql.watchQuery(options)) as Observable<{ data: T }>;
  }

  mutate<T = IMutation>(options: ImportMutationMixin, raw?: boolean) {
    if (!raw) {
      options.mutation = importQuery(options.mutation);
    }
    return from(this.graphql.mutate(options)) as Observable<{ data: T }>;
  }

  subscribe<T = ISubscription>(options: ImportSubscriptionMixin, raw?: boolean) {
    if (!raw) {
      options.query = importQuery(options.query);
    }
    return from(this.graphql.subscribe(options)) as Observable<{ data: T }>;
  }
}

interface ImportQueryMixin extends QueryOptions {
  query: DocumentTypes | any;
}

interface ImportSubscriptionMixin extends SubscriptionOptions {
  query: DocumentTypes | any;
}

interface ImportMutationMixin extends MutationOptions {
  mutation: DocumentTypes | any;
  update?(proxy: DataProxy, res: { data: IMutation }): void;
}
